import moment from 'moment'

/** TOPシフト表の表示日切替時刻（JST想定・ローカル時刻） */
export const SHIFT_SWITCH_HOUR = 13

/**
 * TOPシフト表示用の業務日を返す。
 * 切替時刻未満 → 前日、以降 → 当日。
 * @param {moment.Moment|Date|string|number} [now]
 * @returns {moment.Moment}
 */
export function getShiftBusinessDay(now = moment()) {
  const current = moment(now)
  const switchAt = current.clone().hour(SHIFT_SWITCH_HOUR).minute(0).second(0).millisecond(0)
  if (current.isBefore(switchAt)) {
    return current.clone().subtract(1, 'day').startOf('day')
  }
  return current.clone().startOf('day')
}

/**
 * responderShift 用の startDay（YYYY-MM-DD）
 */
export function getShiftStartDay(now = moment()) {
  return getShiftBusinessDay(now).format('YYYY-MM-DD')
}

/**
 * TOP見出し用テキスト
 */
export function formatShiftSectionTitle(lang, now = moment()) {
  const day = getShiftBusinessDay(now)
  if (lang === 'en') {
    return `${day.format('YYYY MMM D')} shift`
  }
  return `${day.clone().locale('ja').format('YYYY年M月D日')}シフト`
}
